<template>
    <div :class="$style['package-table-div']" class="page-background" v-if="goodsData && goodsData.goodsDTO && goodsData.goodsDTO.goodsData">
        <table :class="$style['package-table']">
            <th>
                <td></td>
                <td>商品名称</td>
                <td>价格</td>
                <td>上架时间</td>
                <td>类型</td>
                <td>分组</td>
            </th>
            <tr >
                <td>
                <pt-img class="banner-picture"
                        :src="goodsData.goodsDTO.goodsData.mainPicture" styleName="mall-goods-banner-pictures" style="vertical-align:middle"></pt-img>
                </td>
                <td>{{goodsData.goodsDTO.goodsData.name}}</td>
                <td>
                <template v-if="goodsData.promotionEvent && goodsData.promotionEvent.status=='ACTIVATED'">
                    <div v-for="(item,index) in fullPayPrice(goodsData,true)" :key='index'>
                    <div :style="{textDecoration: (isInPromotion(goodsData.promotionEvent.promotionData)&&(item.active_text||item.active_price)) ? 'line-through' : 'none'}" >
                        <span class="price_show_text">{{item.text}}</span>
                        <span>{{item.price}}</span>
                    </div>
                    <div :style="{color:goodsData.promotionStatusColor}" v-if="item.active_text||item.active_price">
                        <span class="price_show_text">{{item.active_text}}</span>
                        <span>{{item.active_price}}</span>
                    </div>
                    </div>
                </template>
                <div v-else>
                    <div v-for="(item,index) in fullPayPrice(goodsData)" :key="index">
                    <span class="price_show_text">{{item.text}}</span>
                    <span>{{item.price}}</span>
                    </div>
                </div>
                </td>
                <td>{{goodsData.putOnSaleTime}}</td>
                <td>{{goodsData.goodsDTO.goodsData.typeName}}</td>
                <td>{{goodsData.goodsDTO.goodsData.groupName}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import { getCurrentTimestamp } from 'utils/formUtils'
export default {
  props: {
    goodsData: {
      type: Object
    }
  },
  data () {
    return {

    }
  },
  methods: {
    isInPromotion (promotionData) {
      let now = getCurrentTimestamp()
      return now > promotionData.startTime
    },
    // 价格显示(全款)
    fullPayPrice (row, isActive) {
      let res = []
      console.log('row==========', JSON.parse(JSON.stringify(row)))
      let activePrice = (row.promotionMinPrice && row.promotionMaxPrice) ? ('¥' + row.promotionMinPrice + '-¥' + row.promotionMaxPrice) : '¥' + row.promotionPrice
      let activeBalance = (row.promotionMinBalance && row.promotionMaxBalance) ? ('¥' + row.promotionMinBalance + '-¥' + row.promotionMaxBalance) : row.promotionBalance
      let depostAndBalance = [
        {
          // active_text: '订金',
          text: '订金',
          price: row.final_deposit
        },
        {
          active_text: '尾款',
          text: '尾款',
          price: row.final_balance,
          active_price: activeBalance
        }
      ]
      let fullObj = {
        active_text: '全款',
        text: '全款',
        price: row.final_price,
        active_price: activePrice
      }
      if (!row.paymentModes || !row.paymentModes.length) {
        res.push({
          active_price: activePrice,
          price: row.final_price
        })
      } else if (row.paymentModes.length === 1) {
        if (row.paymentModes.indexOf('LUMP_SUM') > -1) {
          res.push({
            active_price: activePrice,
            price: row.final_price
          })
        } else if (row.paymentModes.indexOf('DEPOSIT_AND_BALANCE') > -1) {
          res = res.concat(depostAndBalance)
        }
      } else {
        res = res.concat(depostAndBalance)
        res.push(fullObj)
      }

      return res
    }
  }
}
</script>

<style module lang="less">
.package-table-div{
    margin-top: 10px;
    padding: 10px 20px 30px;
    max-width: 800px;
    line-height: 30px !important;
  }
  .package-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
    }
  }
  .banner-picture{
        img{
            max-width: 100px;
            border-radius: 10px;
        }
}
.price_show_text{
  margin-right: 10px
}
</style>
